import Vue from 'vue'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import config from './config'
import store from '@/store/store.js'
import { removeCookieToken } from '@/utils/auth'
import Uitls from '@/utils/index'

// 创建取消请求的令牌
const { CancelToken } = axios
const cancelTokens = {} // 存储请求的取消令牌

const service = axios.create({
    baseURL: config.API_DOMAIN,
    timeout: 30 * 1000
})

service.interceptors.request.use(
    (config) => {
        // 如果传入的是绝对路径地址，则不使用 baseURL
        if (config.url.startsWith('http://') || config.url.startsWith('https://')) {
            config.baseURL = ''
        }
        // 公共参数
        const { channel = Uitls.getNowChannel() } = {}
        const params = {
            _ts: +new Date(),
            channel
        }
        if (config.params && config.params['channel']) {
            params.channel = config.params.channel
        }
        if (!config.noChannel) {
            // 上传图片
            config.headers['Sf-Platform'] = 'box_family'
            params.channel && (config.headers['Sf-Channel'] = params.channel)
        }

        // 添加公共请求头
        if (store.state.token) {
            if (!config.noAuth) {
                // 图片上传接口不需要认证
                config.headers['Authorization'] = store.state.token
            }
        }
        // 取消请求
        const source = CancelToken.source()
        cancelTokens[config.url] = source
        config.cancelToken = source.token
        // 添加公共参数
        config.params = { ...params, ...config.params }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use((response) => {
    const res = response.data

    if (res.code === 101014) {
        removeCookieToken()
        store.commit('resetState')
        Vue.prototype.$NormalDialog.show({ title: '温馨提示', msg: res.msg })
    }

    if (res.code == 200 && Uitls.isObject(res.data) && res.data.list === null) {
        res.data.list = []
    }
    return res
})

axiosRetry(service, {
    retries: 3,
    retryCondition: (error) => {
        try {
            let statusStr = String(error.response.status)
            if (statusStr == '401') {
                removeCookieToken()
                store.commit('resetState')
                Vue.prototype.$Toast.show('登录状态已失效，请重新登录', 1000)
                return false
            } else if (statusStr.startsWith('5') || statusStr.startsWith('4')) {
                // 响应状态码4开头和5开头认为该次请求失败，需要重试
                return true
            }
        } catch (error) {
            return true
        }
    },
    retryDelay: (retryCount) => {
        return retryCount * 1000
    }
})

export const cancelRequest = (url) => {
    if (cancelTokens[url]) {
        cancelTokens[url].cancel('Request canceled by user.')
        delete cancelTokens[url] // 取消后删除对应的取消令牌
    }
}
export default service
